import { graphql } from '../../gql';

export const CurrentUserDocument = graphql(/* GraphQL */ `
  query CurrentUser {
    currentUser {
      id
      name
      isServiceUser
      isSystemAdmin
      hasAcceptedTerms
      hasGivenMarketingConsent
      avatarUrl
      username
      userEmails {
        nodes {
          id
          email
        }
      }
      accountMemberships {
        nodes {
          id
          account {
            name
            id
            state {
              id
              name
              code
            }
          }
          role {
            name
            id
          }
        }
      }
      inviteLinks {
        nodes {
          id
          state
          account {
            id
            name
          }
          role {
            id
            name
          }
        }
      }
    }
  }
`);
